/**
 *
 * Copyright (c) 2019-present, wobe-systems GmbH
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * to be found in the LICENSE file in the root directory of this source tree.
 */

import { SVG_TO_BASE64_PREFIX } from '../shared';

const knownSymbols: string[] = [
  'General',
  'Inlet',
  'Outlet',
  'Merger',
  'Selector',
  'Converter',
  'Filter',
  'SignalIn',
  'SignalOut',
];

/**
 * Chooses the icon for the brick to
 * display on any component
 *
 * @param brickFamily Family the brick belongs to
 * @param brickimage The custom image of the brick
 *
 * @returns:
 * @param brickimage if availabe
 * @else standard icon of brick from family
 */
export function getBrickIcon(brickFamily: string, brickimage: string = '') {
  if (brickimage) {
    return `${SVG_TO_BASE64_PREFIX}${brickimage}`;
  }

  const brickIcon: string = knownSymbols.find((s: string) => s === brickFamily) || 'General';
  return require(`@/assets/images/bricks/${brickIcon}.png`);
}

/**
 * If package image is availabe, adds the
 * appropriate SVG prefix to display in the UI
 *
 * @param packageImage The image of the package
 * @returns Either the BASE64 version of the SVG package image
 * @else Standard package icon
 */
export function getPackageIcon(packageImage: string = '') {
  if (packageImage) {
    return `${SVG_TO_BASE64_PREFIX}${packageImage}`;
  }

  return require('@/assets/images/package.svg');
}

/**
 * If workspace image/icon is availabe, adds the
 * appropriate SVG prefix to display in the UI
 *
 * @param workspaceIcon The workspace icon
 * @returns Either the BASE64 version of the SVG package image
 * @else Standard package icon
 */
export function getWorkspaceIcon(workspaceIcon: string = '') {
  if (workspaceIcon) {
    return `${SVG_TO_BASE64_PREFIX}${workspaceIcon}`;
  }

  return require('@/assets/images/workspace.svg');
}
